<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-modal id="modal-upload" title="آپلود مدیا" centered ok-only ok-title="بستن">
      <b-form>
        <b-button class="mt-2 col-12 col-md-4" variant="warning" @click="$refs.refInputEl3.click()">
          <input ref="refInputEl3" type="file" class="d-none" @change="select" />
          <span>بارگذاری</span> {{ file ? file.name : "" }}
        </b-button>
        <b-button
            :disabled="isBtnsDisabled"
            variant="primary"
            class="mt-2 mb-sm-0 ml-2 col-12 col-md-2"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="handleUpload(false, quality, uploadParentId)"
        >
          ثبت
        </b-button>
      </b-form>
      <b-row class="mt-2">
        <b-col cols="6"> تعداد چانک‌ها: {{ totalChunks }} </b-col>
        <b-col cols="6">
          <span>حجم آپلود شده: </span>
          <span>{{ formatFileSize(uploadedBytes) }} </span> از
          <span>{{ formatFileSize(totalSize) }} </span>
        </b-col>
        <b-col cols="6"> آخرین چانک آپلود شده: {{ lastUploadedChunk }} </b-col>
        <b-col cols="6"> سرعت: {{ formatFileSize(speedSpan) }} /s </b-col>
        <b-col cols="6"> زمان تخمینی باقی‌مانده: {{ formatTime(etaSpan) }} </b-col>
      </b-row>
      <b-progress v-if="uploaded2 !== 0 && uploaded2 !== 100" :value="uploaded2" max="100" variant="primary" class="mt-2" />
      <b-alert :show="done === true" variant="success" class="col-12">
        <div class="alert-body mt-2">
          <feather-icon class="mr-25" icon="CheckIcon" />
          <span class="ml-25">فایل شما آپلود شده است.</span>
        </div>
      </b-alert>
      <b-alert :show="errorAlert" variant="danger" class="col-12">
        <div class="alert-body mt-2">
          <feather-icon class="mr-25" icon="CloseIcon" />
          <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
        </div>
      </b-alert>
    </b-modal>

    <div v-if="medias">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-form>
              <b-row>
                <b-col cols="12">
                  <h2>بارگذاری مدیای جدید</h2>
                  <b-button :disabled="isBtnsDisabled" class="mt-2 col-12 col-md-4" variant="warning" @click="$refs.refInputEl2.click()">
                    <input ref="refInputEl2" type="file" class="d-none" @change="select" />
                    <span>بارگذاری</span> {{ file ? file.name : "" }}
                  </b-button>
                  <b-button
                      :disabled="isBtnsDisabled"
                      variant="primary"
                      class="mt-2 mb-sm-0 ml-2 col-12 col-md-2"
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      @click="handleUpload(false, 1, null)"
                  >
                    ثبت
                  </b-button>
                  <b-row class="mt-2">
                    <b-col cols=""> تعداد چانک‌ها: {{ totalChunks }} </b-col>
                    <b-col cols="">
                      <span>حجم آپلود شده: </span>
                      <span>{{ formatFileSize(uploadedBytes) }} </span> از
                      <span>{{ formatFileSize(totalSize) }} </span>
                    </b-col>
                    <b-col cols=""> آخرین چانک آپلود شده: {{ lastUploadedChunk }} </b-col>
                    <b-col cols=""> سرعت: {{ formatFileSize(speedSpan) }} /s </b-col>
                    <b-col cols=""> زمان تخمینی باقی‌مانده: {{ formatTime(etaSpan) }} </b-col>
                  </b-row>
                  <b-alert :show="true" variant="warning" class="col-md-6 col-12">
                    <div class="alert-body mt-2">
                      <feather-icon class="mr-25" icon="CheckIcon" />
                      <span class="ml-25">توجه : اگر مدیای مورد نظر شما برای آپلود ویدیو میباشد به صورت پیشفرض با کیفیت 1080 ثبت میشود.</span>
                    </div>
                  </b-alert>
                </b-col>
              </b-row>
            </b-form>

            <b-progress v-if="uploaded2 !== 0 && uploaded2 !== 100" :value="uploaded2" max="100" variant="primary" class="mt-2" />
            <b-alert :show="done === true" variant="success" class="col-md-2 col-12">
              <div class="alert-body mt-2">
                <feather-icon class="mr-25" icon="CheckIcon" />
                <span class="ml-25">فایل شما آپلود شده است.</span>
              </div>
            </b-alert>
            <b-alert :show="errorAlert" variant="danger" class="col-md-2 col-12">
              <div class="alert-body mt-2">
                <feather-icon class="mr-25" icon="CloseIcon" />
                <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
              </div>
            </b-alert>
          </b-card>

          <div v-if="productType == 2 || productType == 5 || productType == 8 || productType == 9" class="w-100">
            <b-card v-if="medias.videos.length > 0">
              <b-row class="px-2">
                <h3>ویدیو</h3>
                <div class="row mt-5">
                  <video preload="none" class="col-12" controls style="max-height: 30rem;">
                    <source :src="`${baseURL}media/file/video/` + medias.videos[0].pictureUrl" />
                  </video>
                  <b-button class="m-2" variant="danger" v-b-modal.modal-delete @click="showModal(medias.videos[0].pictureUrl)">
                    <feather-icon icon="TrashIcon" size="20" />
                  </b-button>
                  <b-button class="m-2" variant="primary" @click="showChangeNameModal(medias.videos[0].mediaId, medias.videos[0].title.split('.')[0])" v-b-modal.modal-edit-name>
                    <feather-icon icon="EditIcon" size="20" />
                  </b-button>
                  <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority @click="showChangePriorityModal(medias.videos[0].mediaId, medias.videos[0].priority)">
                    <feather-icon icon="AlignCenterIcon" size="20" />
                  </b-button>
                  <b-form-checkbox switch class="m-2" v-model="medias.videos[0].isLocked" @change="toggleMediaLock(medias.videos[0])">
                    قفل/بازکردن
                  </b-form-checkbox>
                </div>
              </b-row>
            </b-card>
            <b-card v-if="productType == 8">
              <b-col cols="12">
                <b-form-group class="mb-2" label="توضیحات" label-for="product-content">
                  <ckEditorMain ref="editorContent" @getEditorContent="setEditorContent" :defaultContent="testDescription" />
                </b-form-group>
                <b-button class="m-2" variant="primary" @click="setTestDescription()"> ویرایش </b-button>
              </b-col>
            </b-card>
          </div>

          <div v-if="productType == 1 || productType == 3 || productType == 4 || productType == 6">
            <section v-if="medias.videos.length > 0" id="card-navigation">
              <b-row v-for="video in medias.videos" :key="video.mediaId">
                <b-col v-if="video.parentId === 0 || video.parentId === null" md="12">
                  <b-card class="text-center">
                    <b-tabs pills nav-class="mb-3">
                      <b-tab title="1080" active>
                        <app-collapse accordion class="col-12">
                          <app-collapse-item :title="video.title.split('.')[0]">
                            <video preload="none" class="col-12" controls style="max-height: 30rem;">
                              <source :src="`${baseURL}media/file/video/` + video.pictureUrl" />
                            </video>

                            <b-button v-if="video.arvanCloudVideoId === null" class="m-2" variant="info" @click="arvanObj.mediaId = video.mediaId" v-b-modal.modal-arvan>
                              <feather-icon icon="UnlockIcon" size="20" />
                            </b-button>
                            <b-button v-else class="m-2" variant="info">
                              <span v-if="video.aravanStatus === 'queue_download'">در صف دانلود ابرآروان</span>
                              <span v-if="video.aravanStatus === 'queue_convert'">در صف تبدیل</span>
                              <span v-if="video.aravanStatus === 'converting'">در حال تبدیل</span>
                              <span @click="arvanObj.mediaId = video.mediaId" v-b-modal.modal-arvan v-if="video.aravanStatus && video.aravanStatus.toLowerCase().includes('fail')">
                                <feather-icon icon="UnlockIcon" size="20" /> آپلود با مشکل مواجه شده دوباره تلاش کنید
                              </span>
                              <span v-if="video.aravanStatus === 'complete'">
                                <feather-icon icon="LockIcon" size="20" />
                                <span class="ml-1">محافظت شده</span>
                              </span>
                            </b-button>

                            <b-button class="m-2" variant="danger" v-b-modal.modal-video-delete @click="tempVideoObject = video">
                              <feather-icon icon="TrashIcon" size="20" />
                            </b-button>
                            <b-button class="m-2" variant="primary" @click="showChangeNameModal(video.mediaId, video.title.split('.')[0])" v-b-modal.modal-edit-name>
                              <feather-icon icon="EditIcon" size="20" />
                            </b-button>
                            <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority @click="showChangePriorityModal(video.mediaId, video.priority)">
                              <feather-icon icon="AlignCenterIcon" size="20" />
                            </b-button>
                            <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type @click="selectMediaForMediaGroup(video.mediaId, video.mediaGroupType)">
                              <feather-icon icon="BookOpenIcon" size="20" />
                            </b-button>
                            <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable @click="selectMediaForIsReachable(video.mediaId, video.isReachable)">
                              <feather-icon icon="SlashIcon" size="20" />
                            </b-button>
                            <b-form-checkbox switch class="m-2" v-model="video.isLocked" @change="toggleMediaLock(video)">
                              قفل/بازکردن
                            </b-form-checkbox>
                          </app-collapse-item>
                        </app-collapse>
                      </b-tab>

                      <b-tab title="720">
                        <template v-for="mv in medias.videos">
                          <app-collapse v-if="mv.parentId === video.mediaId && mv.quality === 2" accordion class="col-12" :key="mv.mediaId">
                            <app-collapse-item :title="mv.title.split('.')[0]">
                              <video preload="none" class="col-12" controls style="max-height: 30rem;">
                                <source :src="baseURL + 'media/file/video/' + mv.pictureUrl" />
                              </video>
                              <b-button class="m-2" variant="danger" v-b-modal.modal-delete @click="showModal(mv.pictureUrl)">
                                <feather-icon icon="TrashIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="primary" @click="showChangeNameModal(mv.mediaId, mv.title.split('.')[0])" v-b-modal.modal-edit-name>
                                <feather-icon icon="EditIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority @click="showChangePriorityModal(mv.mediaId, mv.priority)">
                                <feather-icon icon="AlignCenterIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type @click="selectMediaForMediaGroup(mv.mediaId, mv.mediaGroupType)">
                                <feather-icon icon="BookOpenIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable @click="selectMediaForIsReachable(mv.mediaId, mv.isReachable)">
                                <feather-icon icon="SlashIcon" size="20" />
                              </b-button>
                              <b-form-checkbox switch class="m-2" v-model="mv.isLocked" @change="toggleMediaLock(mv)">
                                قفل/بازکردن
                              </b-form-checkbox>
                            </app-collapse-item>
                          </app-collapse>
                        </template>
                        <b-button class="m-2" variant="warning" v-b-modal.modal-upload @click="setUploadParentId(video.mediaId, 2)">
                          آپلود ویدیو (کیفیت 720)
                        </b-button>
                      </b-tab>

                      <b-tab title="480">
                        <template v-for="mv in medias.videos">
                          <app-collapse v-if="mv.parentId === video.mediaId && mv.quality === 3" accordion class="col-12" :key="mv.mediaId">
                            <app-collapse-item :title="mv.title.split('.')[0]">
                              <video preload="none" class="col-12" controls style="max-height: 30rem;">
                                <source :src="baseURL + 'media/file/video/' + mv.pictureUrl" />
                              </video>
                              <b-button class="m-2" variant="danger" v-b-modal.modal-delete @click="showModal(mv.pictureUrl)">
                                <feather-icon icon="TrashIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="primary" @click="showChangeNameModal(mv.mediaId, mv.title.split('.')[0])" v-b-modal.modal-edit-name>
                                <feather-icon icon="EditIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority @click="showChangePriorityModal(mv.mediaId, mv.priority)">
                                <feather-icon icon="AlignCenterIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type @click="selectMediaForMediaGroup(mv.mediaId, mv.mediaGroupType)">
                                <feather-icon icon="BookOpenIcon" size="20" />
                              </b-button>
                              <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable @click="selectMediaForIsReachable(mv.mediaId, mv.isReachable)">
                                <feather-icon icon="SlashIcon" size="20" />
                              </b-button>
                              <b-form-checkbox switch class="m-2" v-model="mv.isLocked" @change="toggleMediaLock(mv)">
                                قفل/بازکردن
                              </b-form-checkbox>
                            </app-collapse-item>
                          </app-collapse>
                        </template>
                        <b-button class="m-2" variant="warning" v-b-modal.modal-upload @click="setUploadParentId(video.mediaId, 3)">
                          آپلود ویدیو (کیفیت 480)
                        </b-button>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </b-col>
              </b-row>
            </section>

            <b-card v-if="medias.podcasts.length > 0">
              <b-row class="px-2">
                <h3>پادکست ها</h3>
                <app-collapse accordion class="col-12">
                  <app-collapse-item v-for="podcast in medias.podcasts" :key="podcast.mediaId" :title="podcast.title.split('.')[0]">
                    <audio class="col-12" preload="none" controls crossorigin playsinline>
                      <source :src="baseURL + 'media/file/podcast/' + podcast.pictureUrl" />
                    </audio>
                    <b-button class="m-2" variant="danger" v-b-modal.modal-delete @click="showModal(podcast.pictureUrl)">
                      <feather-icon icon="TrashIcon" size="20" />
                    </b-button>
                    <b-button class="m-2" variant="primary" @click="showChangeNameModal(podcast.mediaId, podcast.title.split('.')[0])" v-b-modal.modal-edit-name>
                      <feather-icon icon="EditIcon" size="20" />
                    </b-button>
                    <b-button class="m-2" variant="success" v-b-modal.modal-edit-priority @click="showChangePriorityModal(podcast.mediaId, podcast.priority)">
                      <feather-icon icon="AlignCenterIcon" size="20" />
                    </b-button>
                    <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type @click="selectMediaForMediaGroup(podcast.mediaId, podcast.mediaGroupType)">
                      <feather-icon icon="BookOpenIcon" size="20" />
                    </b-button>
                    <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable @click="selectMediaForIsReachable(podcast.mediaId, podcast.isReachable)">
                      <feather-icon icon="SlashIcon" size="20" />
                    </b-button>
                    <b-form-checkbox switch class="m-2" v-model="podcast.isLocked" @change="toggleMediaLock(podcast)">
                      قفل/بازکردن
                    </b-form-checkbox>
                  </app-collapse-item>
                </app-collapse>
              </b-row>
            </b-card>

            <b-card v-if="medias.images.length > 0">
              <b-row class="px-2">
                <h3>عکس ها</h3>
                <app-collapse accordion class="col-12">
                  <div class="row">
                    <div v-for="image in medias.images" :key="image.mediaId" class="col-md-4 mt-3">
                      <img class="col-12" style="height: 400px" :src="baseURL + 'media/file/picture/' + image.pictureUrl" alt="profile" />
                      <b-button class="col-4 m-2" variant="danger" v-b-modal.modal-delete @click="showModal(image.pictureUrl)">
                        <feather-icon icon="TrashIcon" size="20" />
                      </b-button>
                      <b-button class="col-4 m-2" variant="success" v-b-modal.modal-edit-priority @click="showChangePriorityModal(image.mediaId, image.priority)">
                        <feather-icon icon="AlignCenterIcon" size="20" />
                      </b-button>
                      <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type @click="selectMediaForMediaGroup(image.mediaId, image.mediaGroupType)">
                        <feather-icon icon="BookOpenIcon" size="20" />
                      </b-button>
                      <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable @click="selectMediaForIsReachable(image.mediaId, image.isReachable)">
                        <feather-icon icon="SlashIcon" size="20" />
                      </b-button>
                      <b-form-checkbox switch class="m-2" v-model="image.isLocked" @change="toggleMediaLock(image)">
                        قفل/بازکردن
                      </b-form-checkbox>
                    </div>
                  </div>
                </app-collapse>
              </b-row>
            </b-card>

            <b-card v-if="medias.pdFs.length > 0">
              <b-row class="px-2">
                <h3>فایل ها</h3>
                <div v-for="file in medias.pdFs" :key="file.mediaId" class="col-12">
                  <div class="row">
                    <div class="col-md-4 mt-3">
                      <a class="d-block" :href="baseURL + 'media/file/pdf/' + file.pictureUrl" download target="_blank">{{ file.title.split('.')[0] }}</a>
                      <b-button class="" variant="danger" v-b-modal.modal-delete @click="showModal(file.pictureUrl)">
                        <feather-icon icon="TrashIcon" size="20" />
                      </b-button>
                      <b-button class="m-2" variant="primary" @click="showChangeNameModal(file.mediaId, file.title.split('.')[0])" v-b-modal.modal-edit-name>
                        <feather-icon icon="EditIcon" size="20" />
                      </b-button>
                      <b-button class="" variant="success" v-b-modal.modal-edit-priority @click="showChangePriorityModal(file.mediaId, file.priority)">
                        <feather-icon icon="AlignCenterIcon" size="20" />
                      </b-button>
                      <b-button class="m-2" variant="warning" v-b-modal.modal-edit-type @click="selectMediaForMediaGroup(file.mediaId, file.mediaGroupType)">
                        <feather-icon icon="BookOpenIcon" size="20" />
                      </b-button>
                      <b-button class="m-2" variant="secondary" v-b-modal.modal-edit-isReachable @click="selectMediaForIsReachable(file.mediaId, file.isReachable)">
                        <feather-icon icon="SlashIcon" size="20" />
                      </b-button>
                      <b-form-checkbox switch class="m-2" v-model="file.isLocked" @change="toggleMediaLock(file)">
                        قفل/بازکردن
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal id="modal-delete" centered ok-title="حذف" cancelTitle="انصراف" @ok="deleteMedia(deleteItem)">
      <span>حذف شود؟</span>
    </b-modal>
    <b-modal id="modal-edit-name" title="ویرایش نام فایل" centered ok-title="ثبت" cancelTitle="انصراف" @ok="updateMediaName">
      <input @keydown.enter="updateMediaName" type="text" v-model="newName" />
    </b-modal>
    <b-modal id="modal-edit-priority" title="ویرایش اولویت فایل" centered ok-title="ثبت" cancelTitle="انصراف" @ok="updateMediaPriority">
      <input @keydown.enter="updateMediaPriority" type="number" v-model="newPriority" />
    </b-modal>
    <b-modal id="modal-edit-type" title="ویرایش دسته بندی فایل" centered ok-title="ثبت" cancelTitle="انصراف" no-close-on-backdrop @ok="updateMediaGroupType">
      <b-row>
        <b-col cols="12">
          <span>دسته بندی ها :</span>
          <b-form-group label-cols="12">
            <v-select class="mt-1" v-model="selectedTypeForMediaGroup" :clearable="false" label="option" :options="mediaGroupTypes" :reduce="option => option.value" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-arvan" title="محافظت از فایل" centered ok-title="ثبت" cancelTitle="انصراف" @ok="arvanCreate">
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-row>
          <span class="mx-1 mb-1">عنوان :</span>
          <b-col cols="12">
            <validation-provider name="title" rules="required">
              <b-form-input id="title" v-model="arvanObj.title" class="form-control"></b-form-input>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-edit-isReachable" title="ویرایش دسترسی کاربران به فایل" centered ok-title="ثبت" cancelTitle="انصراف" no-close-on-backdrop @ok="setReachableMedia">
      <b-row>
        <b-col cols="12">
          <span>انتخاب دسترسی :</span>
          <b-form-group label-cols="12">
            <v-select class="mt-1" v-model="selectedIsReachableType" :clearable="false" label="option" :options="ReachableTypes" :reduce="option => option.value" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-video-delete" centered ok-title="حذف" cancelTitle="انصراف" @ok="sendMediaRemoveRequest()">
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAlert, BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BOverlay,
  BRow, BTab, BTabs, BProgress, BModal, BFormCheckbox
} from "bootstrap-vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import vSelect from "vue-select";
import axios from "axios";
import { getUserData } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  ProductGetProductsMediasForAdminRequest,
  ProductSetMediaGroupTypeRequest,
  ProductSetReachableRequest,
  PsychologicalTestGetByProductId,
  UpdateResultDescription
} from "@/libs/Api/Product";
import { MediaDeleteByPictureUrlRequest } from "@/libs/Api/Product";
import { MediaChangeMediaNameRequest, MediaChangePriorityRequest } from "@/libs/Api/Media";
import Helper from "@/libs/Helper";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ArvanCloudVideoCreateRequest, DeleteArvanVideo } from "@/libs/Api/ArvanCloud";
import ckEditorMain from "@/views/components/ckEditorMain.vue";

export default {
  title: 'مدیای محصول - پنل ادمین رها مزون',
  name: "ECommerceAddProductMediaWithChunk",
  components: {
    ckEditorMain,
    BCard, BRow, BCol, BButton, BAlert, BTab, BTabs, BForm, BFormGroup, BFormInput,
    BOverlay, BProgress, BModal, AppCollapse, AppCollapseItem, vSelect,
    ValidationProvider, ValidationObserver, BFormCheckbox
  },
  data() {
    return {
      productId: this.$route.params.id,
      productType: this.$route.query.productType,
      userToken: getUserData().token,
      medias: null,
      errorAlert: false,
      done: null,
      overlay: true,
      deleteItem: null,
      baseURL: Helper.baseUrl,
      types: [
        { name: 'دوره', value: 1 },
        { name: 'لایو', value: 2 },
        { name: 'فایل', value: 3 },
        { name: 'پادکست', value: 4 },
        { name: 'پست آموزشی', value: 5 },
        { name: 'استوری', value: 9 },
      ],
      file: null,
      chunks: [],
      uploaded: 0,
      uploaded2: 0,
      namePictureURL: null,
      priorityPictureURL: null,
      newName: '',
      newPriority: '',
      uploadParentId: null,
      quality: null,
      selectedMediaIdForMediaGroup: null,
      selectedTypeForMediaGroup: null,
      tempVideoObject: null,
      temptest: null,
      mediaGroupTypes: [
        { option: 'ویدئو', value: 1 },
        { option: 'فایل', value: 9 },
      ],
      arvanObj: { title: '', description: '', mediaId: null },
      selectedIsReachableType: null,
      testDescription: '',
      selectedMediaIdForIsReachableType: null,
      ReachableTypes: [
        { option: 'قابل دسترسی', value: true },
        { option: 'غیر قابل دسترسی', value: false },
      ],
      uploadInProgress: false,
      chunkSize: 10 * 1024 * 1024,
      currentChunkSpan: 0,
      fileId: 0,
      uploadStats: { startTime: null, chunksCompleted: 0, totalBytes: 0, speed: 0, estimatedTime: 0 },
      totalChunks: 0,
      lastUploadedChunk: 0,
      uploadedBytes: 0,
      speedSpan: 0,
      etaSpan: 0,
      totalSize: 0,
      isBtnsDisabled: false
    };
  },
  async created() {
    await this.getProductMedias();
    if (this.productType == 8) await this.getTestDescription();
  },
  methods: {
    generateFileId() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    formatTime(seconds) {
      if (seconds < 60) return `${Math.round(seconds)} ثانیه`;
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = Math.round(seconds % 60);
      return `${minutes} دقیقه و ${remainingSeconds} ثانیه`;
    },
    addLog(msg, type = 'info') {
      const color = type === 'error' ? 'red' : type === 'success' ? 'green' : type === 'warning' ? 'yellow' : 'green';
      console.log(`%c ${msg}`, `color: ${color}`);
    },
    /**
     * resume: ادامه آپلود از آخرین chunk
     * quality: کیفیت ویدیو (پیشفرض 1 = 1080) - برای آپلودهای زیرمجموعه (720/480) از مودال پاس داده میشود
     * parentId: شناسه ویدیوی والد - فقط برای آپلودهای زیرمجموعه از داخل مودال پر میشود
     */
    async handleUpload(resume = false, quality = 1, parentId = null) {
      if (!this.file) {
        this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات ناموفق', icon: 'CheckIcon', variant: 'danger', text: 'لطفاً فایل انتخاب کنید' } });
        return;
      }
      if (this.chunkSize <= 0) {
        this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات ناموفق', icon: 'CheckIcon', variant: 'danger', text: 'حجم chunk باید بزرگتر از صفر' } });
        return;
      }
      if (this.uploadInProgress) {
        this.addLog('آپلود در حال انجام است', 'warning');
        return;
      }
      this.uploadInProgress = true;
      this.done = null;
      this.errorAlert = false;
      this.totalSize = this.file.size;
      this.uploadStats = { startTime: new Date(), chunksCompleted: 0, totalBytes: this.file.size, speed: 0, estimatedTime: 0 };
      if (!resume || !this.fileId) this.fileId = this.generateFileId();
      this.totalChunks = Math.ceil(this.file.size / this.chunkSize);
      let startChunk = resume ? this.lastUploadedChunk + 1 : 0;
      this.addLog(`شروع آپلود ${resume ? 'ادامه ' : ''}فایل: ${this.file.name}`, 'info');
      this.addLog(`حجم فایل: ${this.formatFileSize(this.file.size)}`, 'info');
      this.addLog(`تعداد chunks: ${this.totalChunks}`, 'info');
      this.addLog(`حجم هر chunk: ${this.formatFileSize(this.chunkSize)}`, 'info');
      this.addLog(`شروع از chunk: ${startChunk + 1}`, 'info');

      for (let i = startChunk; i < this.totalChunks; i++) {
        const start = i * this.chunkSize;
        const end = Math.min(start + this.chunkSize, this.file.size);
        const chunk = this.file.slice(start, end);
        this.currentChunkSpan = i + 1;
        try {
          const chunkStartTime = new Date();
          await this.uploadChunk(i, this.totalChunks, chunk, this.file.name, 0, quality, parentId);
          const chunkTime = (new Date() - chunkStartTime) / 1000;
          const chunkSpeed = chunk.size / chunkTime;
          this.uploadStats.chunksCompleted++;
          this.uploadStats.speed = chunkSpeed;
          const remainingChunks = this.totalChunks - (i + 1);
          this.uploadStats.estimatedTime = remainingChunks * (this.chunkSize / chunkSpeed);
          this.uploaded2 = Math.round(((i + 1) / this.totalChunks) * 100);
          this.lastUploadedChunk = i;
          this.speedSpan = chunkSpeed;
          this.etaSpan = this.uploadStats.estimatedTime;
          this.addLog(`chunk ${i + 1} آپلود شد (${this.formatFileSize(chunkSpeed)}/ثانیه)`, 'success');
        } catch (error) {
          this.addLog(`خطا در آپلود chunk ${i + 1}: ${error.message}`, 'error');
          console.error(error);
          this.uploadInProgress = false;
          this.errorAlert = true;
          break;
        }
      }
      if (this.uploadInProgress) {
        const totalTime = (new Date() - this.uploadStats.startTime) / 1000;
        const averageSpeed = this.file.size / totalTime;
        this.addLog(`آپلود کامل شد! زمان: ${Math.round(totalTime)} ثانیه`, 'success');
        this.addLog(`میانگین سرعت: ${this.formatFileSize(averageSpeed)}/ثانیه`, 'success');
        this.uploaded2 = '100';
        this.speedSpan = 0;
        this.etaSpan = 0;
        this.done = true;
        this.uploadInProgress = false;
      }
      this.getProductMedias();
      this.$bvModal.hide('modal-upload');
    },
    async uploadChunk(chunkNumber, totalChunks, chunkBlob, originalFileName, retryCount = 0, quality = 1, parentId = null) {
      this.isBtnsDisabled = true;
      const maxRetries = 3;
      let lastTime = Date.now();
      let lastLoaded = 0;
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 120000);
        const formData = new FormData();
        formData.append('ChunkNumber', chunkNumber.toString());
        formData.append('TotalChunks', totalChunks.toString());
        formData.append('FileId', this.fileId);
        formData.append('OriginalFileName', originalFileName);
        formData.append('File', chunkBlob, originalFileName);
        let url = Helper.baseUrl + 'api/ChunckedUploader/UploadChunk?productId=' + this.productId + '&productType=' + this.productType + '&quality=' + quality;
        if (parentId) url += '&parentId=' + parentId;
        const chunkConfig = {
          method: 'POST',
          data: formData,
          signal: controller.signal,
          url: url,
          headers: { "Content-Type": "multipart/form-data", 'Authorization': "Bearer " + this.userToken },
          onUploadProgress: progressEvent => {
            const currentTime = Date.now();
            const timeElapsed = (currentTime - lastTime) / 1000;
            const bytesUploaded = progressEvent.loaded - lastLoaded;
            const completedChunks = chunkNumber;
            const completedBytes = completedChunks * this.chunkSize;
            const currentChunkBytes = progressEvent.loaded;
            const totalUploadedBytes = completedBytes + currentChunkBytes;
            this.uploadedBytes = Math.min(totalUploadedBytes, this.file.size);
            this.uploaded2 = Math.min((this.uploadedBytes / this.file.size) * 100, 100);
            const now = Date.now();
            const timeDiff = (now - lastTime) / 1000;
            if (timeDiff > 0.5) {
              this.speedSpan = (bytesUploaded / timeElapsed) / 1024;
              const remainingBytes = this.file.size - this.uploadedBytes;
              if (this.speedSpan > 0) this.etaSpan = remainingBytes / (this.speedSpan * 1024);
              lastTime = currentTime;
              lastLoaded = progressEvent.loaded;
            }
          }
        };
        const response = await axios(chunkConfig);
        if (response.data.isSuccess) {
          clearTimeout(timeoutId);
          this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: response.data.message } });
          this.uploaded2 = 0;
          if (!response.ok && response.status === 500 && retryCount < maxRetries) {
            this.addLog(`خطای سرور، تلاش مجدد (${retryCount + 1}/${maxRetries})...`, 'error');
            await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)));
            return this.uploadChunk(chunkNumber, totalChunks, chunkBlob, originalFileName, retryCount + 1, quality, parentId);
          }
        }
      } catch (error) {
        this.uploaded2 = 0;
        console.error(error);
        if (error.name === 'AbortError' && retryCount < maxRetries) {
          this.addLog(`Timeout، تلاش مجدد (${retryCount + 1}/${maxRetries})...`, 'error');
          await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)));
          return this.uploadChunk(chunkNumber, totalChunks, chunkBlob, originalFileName, retryCount + 1, quality, parentId);
        }
        this.addLog(`خطا در آپلود chunk ${chunkNumber}: ${error.message}`, 'error');
      } finally {
        this.isBtnsDisabled = false;
      }
    },
    async getProductMedias() {
      this.overlay = true;
      let req = new ProductGetProductsMediasForAdminRequest(this);
      req.setId(this.productId);
      await req.fetch(content => { this.medias = content; this.overlay = false; }, () => { this.overlay = false; });
    },
    showModal(param) { this.deleteItem = param; },
    showChangeNameModal(id, name) { this.namePictureURL = id; this.newName = name; },
    showChangePriorityModal(id, priority) { this.priorityPictureURL = id; this.newPriority = priority; },
    select(event) { this.file = event.target.files.item(0); },
    async deleteMedia(pictureUrl) {
      this.overlay = true;
      let req = new MediaDeleteByPictureUrlRequest(this);
      req.setSocialMediaId(pictureUrl);
      await req.fetch(() => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'حذف شد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    async updateMediaName() {
      this.overlay = true;
      let req = new MediaChangeMediaNameRequest(this);
      req.setParams({ socialMediaId: this.namePictureURL, newName: this.newName });
      await req.fetch(() => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'عملیات انجام شد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    setUploadParentId(id, q) { this.uploadParentId = id; this.quality = q; this.file = null; this.totalChunks = 0; this.lastUploadedChunk = 0; this.uploadedBytes = 0; this.uploaded2 = 0; this.done = null; this.errorAlert = false; },
    async updateMediaPriority() {
      this.overlay = true;
      let req = new MediaChangePriorityRequest(this);
      req.setParams({ socialMediaId: this.priorityPictureURL, priority: this.newPriority });
      await req.fetch(() => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'عملیات انجام شد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    selectMediaForMediaGroup(id, type) { this.selectedMediaIdForMediaGroup = id; this.selectedTypeForMediaGroup = type; },
    selectMediaForIsReachable(id, type) { this.selectedMediaIdForIsReachableType = id; this.selectedIsReachableType = type; },
    async updateMediaGroupType() {
      this.overlay = true;
      let req = new ProductSetMediaGroupTypeRequest(this);
      req.setParams({ mediaId: this.selectedMediaIdForMediaGroup, type: this.selectedTypeForMediaGroup });
      await req.fetch(() => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'عملیات انجام شد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    async arvanCreate() {
      if (!this.arvanObj.title.length) {
        this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات ناموفق', icon: 'CloseIcon', variant: 'danger', text: 'عنوان فایل الزامی است.' } });
        return;
      }
      this.overlay = true;
      let req = new ArvanCloudVideoCreateRequest(this);
      req.setParams(this.arvanObj);
      await req.fetch(content => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: content.isSuccess ? 'عملیات موفق' : 'عملیات ناموفق', icon: content.isSuccess ? 'CheckIcon' : 'CloseIcon', variant: content.isSuccess ? 'success' : 'danger', text: content.isSuccess ? 'درخواست شما ارسال شد.' : 'عملیات انجام نشد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    async deleteVideoMedia() {
      this.overlay = true;
      let req = new MediaDeleteByPictureUrlRequest(this);
      req.setSocialMediaId(this.tempVideoObject.pictureUrl);
      await req.fetch(() => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'حذف شد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    async sendMediaRemoveRequest() {
      if (!this.tempVideoObject?.arvanCloudVideoId) await this.deleteVideoMedia();
      else await this.sendDeleteArvanVideo();
    },
    async sendDeleteArvanVideo() {
      this.overlay = true;
      let req = new DeleteArvanVideo(this);
      req.setRequestParam({ videoId: this.tempVideoObject.arvanCloudVideoId });
      await req.fetch(res => { if (res.isSuccess) this.deleteVideoMedia(); });
    },
    async setReachableMedia() {
      this.overlay = true;
      let req = new ProductSetReachableRequest(this);
      req.setParams({ mediaId: this.selectedMediaIdForIsReachableType, isReachable: this.selectedIsReachableType });
      await req.fetch(() => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'عملیات انجام شد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    async getTestDescription() {
      this.overlay = true;
      let req = new PsychologicalTestGetByProductId(this);
      req.setParams({ productId: this.productId });
      await req.fetch(content => { this.temptest = content.data; this.testDescription = content.data.resultDescription; this.overlay = false; }, () => { this.overlay = false; });
    },
    async setTestDescription() {
      this.overlay = true;
      let req = new UpdateResultDescription(this);
      req.setParams({ id: this.temptest.id, resultDescription: this.testDescription });
      await req.fetch(() => { this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'عملیات انجام شد.' } }); this.getProductMedias(); }, () => { this.overlay = false; });
    },
    setEditorContent(content) { this.testDescription = content; },
    async toggleMediaLock(mediaItem) {
      this.overlay = true;
      try {
        const response = await axios({
          method: 'POST',
          url: `${Helper.baseUrl}api/Product/ToggleMediaLock?mediaId=${mediaItem.mediaId}`,
          headers: { 'Authorization': `Bearer ${this.userToken}`, 'Token': this.userToken }
        });
        if (response.data.isSuccess) {
          mediaItem.isLocked = response.data.data.isLocked;
          this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات موفق', icon: 'CheckIcon', variant: 'success', text: 'وضعیت لاک مدیا تغییر کرد.' } });
        } else {
          mediaItem.isLocked = !mediaItem.isLocked;
          this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'عملیات ناموفق', icon: 'CloseIcon', variant: 'danger', text: response.data.errorMessage || 'تغییر وضعیت لاک انجام نشد.' } });
        }
      } catch (error) {
        mediaItem.isLocked = !mediaItem.isLocked;
        console.error(error);
        this.$toast({ component: ToastificationContent, position: 'bottom-center', props: { title: 'خطا', icon: 'CloseIcon', variant: 'danger', text: 'ارتباط با سرور برقرار نشد.' } });
      } finally {
        this.overlay = false;
      }
    }
  }
};
</script>

<style scoped></style>
